// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountAdmin } from './account-admin';
import { AccountUser } from './account-user';
import { JobOrder } from './job-order';
import { ProgramIssuance } from './program-issuance';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramIssuanceUserLog extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK accountAdmin */
  accountAdminId?: string;
  /** Guid FK accountUser */
  accountUserId!: string;
  /** String(2000) */
  adjustmentNote?: string;
  /** Guid FK jobOrder */
  jobOrderId?: string;
  /** DateTimeOffset */
  logTs!: Date;
  /** Guid FK programIssuance */
  programIssuanceId!: string;
  /** Int32 */
  qty!: number;
  /** Guid */
  sourceDetailId?: string;
  /** FK accountAdminId */
  accountAdmin!: AccountAdmin;
  /** FK accountUserId */
  accountUser!: AccountUser;
  /** FK jobOrderId */
  jobOrder!: JobOrder;
  /** FK programIssuanceId */
  programIssuance!: ProgramIssuance;
}

